import React from "react";

export default function SQL_ASC() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_ASC</h1>
      <p>This is the SQL_ASC component generated from the SQL JSON.</p>
    </div>
  );
}
